import { ActivityDto } from '@maia/shared';
import { ReactNode, useId } from 'react';
import { ActivityCard } from './activity-card';
import { useDrawerStore } from './../../../stores/drawer.store';
import { useDocumentPreviewStore } from './../../../stores/document-preview.store';

type ActivityListProps = {
  filterSlot?: ReactNode;
  activities: Array<ActivityDto>;
};

export function ActivityList(props: ActivityListProps) {
  const id = useId();
  const { filterSlot, activities } = props;
  const { openDrawer } = useDrawerStore();
  const openDocumentPreview = useDocumentPreviewStore((state) => state.open);

  return (
    <div className="flex flex-col gap-y-24 w-full">
      {filterSlot}

      <ul className="flex flex-col gap-y-12 w-full">
        {activities.map((activity, index) => (
          <li id={`${id}-${index}`}>
            <ActivityCard
              title={activity.title}
              subtitle={activity.message}
              date={activity.date}
              icon={activity.icon}
              onOpen={() => {
                activity.type === 'Email'
                  ? openDocumentPreview({
                      type: 'email',
                      title: activity.message,
                      data: activity.content,
                    })
                  : openDrawer({ type: 'activity', data: activity });
              }}
            />
          </li>
        ))}
      </ul>
    </div>
  );
}
